import { render, staticRenderFns } from "./LabelsModal.vue?vue&type=template&id=58c5a90a&"
import script from "./LabelsModal.vue?vue&type=script&lang=js&"
export * from "./LabelsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports